import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=6487f928&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=6487f928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487f928",
  null
  
)

export default component.exports